import { ToolBarStandardButtonType, ToolBar, ToolBarStandardButton, ToolBarCustomButton } from "../core/components/toolBar";
import { EditAllocation, EntityTicketEditAllocation, TicketEditAllicationAppProps } from "./editAllocation";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { Helper } from "../core/util/helper";
import { SheetEventType } from "../../siteManagement/sheet";
import { General } from "../../siteManagement/general";
import { NotificationHelper } from "../core/util/notificationHelper";
import { DialogHelper } from "../core/util/dialogHelper";
import { Metadata } from "../core/components/commonApp.js";
import ToolBarContextMenu from "../core/components/mobile/toolBarContextMenu.js";
import React from "react";
export default class Allocations extends React.Component<any, any>{
    private _treeData = [];
    private _translations = {};
    private _dataUrl: string;
    private _treeElementRef: any;
    private _treeRef: kendo.ui.TreeView;
    private _selectedItem: any = null;
    private _error = false;
    private baseTemplate: string = "<input type='radio' name='treeStructurePart' data-ticket-ref='#=item.data.PROBLEMNRREF#' data-direct-parent='#=item.directParent#' data-ticket-id='#=item.id#' />";
    private contextMenu: ToolBarContextMenu;

    constructor(props) {
        super(props)
        this._dataUrl = "ProcedureAllocation/GetTree?problemNr=" + props.entity.ProblemNr;
        this._translations = props.translations;
    }

    private _getTreeData(isRefresh: boolean) {
        return new Promise<void>(resolve => {
            HTTPService.get(this._dataUrl)
                .then(result => {
                    if (!result.Data.error) {
                        this._addParentMarker(result.Data.tree, this.props.entity.ProblemNr);
                        this._treeData.length = 0;
                        if (Helper.hasValue(result.Data.tree)) {
                            this._treeData.push(result.Data.tree);
                        }

                        if (isRefresh) {
                            this._treeRef.dataSource.data(this._treeData);
                            this._selectedItem = null;
                            this._setRadioButtonVisibility();
                        }
                    } else {
                        this._error = true;
                        NotificationHelper.showErrorMessage(result.Data.message);
                    }

                    resolve();
                });
        });
    }

    private _setRadioButtonVisibility = () => {
        $("input[type=radio][name=treeStructurePart][data-direct-parent!=true][data-ticket-ref!=" + this.props.entity.ProblemNr + "]", this._treeElementRef).hide();
    }

    private _openEditWindow = (isNew: boolean) => {
        const sheet = General.Sheet.Manager.createSheet();
        sheet.setTitle(this._translations["WebSMS.Ticket.Allocations.TicketAllocation"]);
        sheet.bind(SheetEventType.SavedSuccessfully, (target) => {
            const selectedTicket = $("input[type=radio][name=treeStructurePart]:checked", this._treeElementRef).attr("data-ticket-id");
            this._getTreeData(true).then(() => {
                if (!isNew) {
                    $("input[type=radio][name=treeStructurePart][data-direct-parent!=true][data-ticket-id=" + selectedTicket + "]", this._treeElementRef).click();
                }
                this.props.context.reloadEntity();
                this.setState({});
            });
        });
        sheet.bind(SheetEventType.Close, () => {

            this.setState({});
        });
        HTTPService.chainBatch
            .add<JsonResultClass<EntityTicketEditAllocation>>("ProcedureAllocation/Init?current=" + this.props.entity.ProblemNr + "&id=" + (isNew ? "" : (this._selectedItem.directParent ? this._selectedItem.childAllocationId : this._selectedItem.data.BEZ_ID)))
            .add<Metadata>(Helper.getMetaData("procedureEditAllocation"))
            .promise()
            .then(result => {
                sheet.show(() => {
                    const props: TicketEditAllicationAppProps = {
                        context: {},
                        dataSources: {},
                        title: this._translations["WebCRM.Administration.BenutzereinstellungenKopieren"],
                        metadata: result[1],
                        entity: result[0].Data,
                        isWindow: true,
                        handleMenuSelect: null,
                        enableMenuItem: null,
                        handleCreateValidator: null,
                        handleFieldChange: null,
                        handleDataLoaded: null,
                        onChange: null
                    };

                    sheet.mountContent(EditAllocation, props);
                });
            });
    }

    private _addParentMarker(node, targetId) {
        if (Helper.hasValue(node)) {
            if (Array.isArray(node.items)) {
                var index = -1;
                if (node.items.some(function (x, i) { if (x.id === targetId) { index = i; return true; } else { return false; }; })) {
                    node.directParent = true;
                    node.childAllocationId = node.items[index].data.BEZ_ID;
                } else {
                    node.directParent = false;
                    for (var i = 0; i < node.items.length; i++) {
                        this._addParentMarker(node.items[i], targetId);
                    }
                }
            } else {
                node.directParent = false;
            }
        }
    }

    private _open = () => {
        this._openEditWindow(false);
    }

    private _create = () => {
        this._openEditWindow(true);
    }

    private _remove = () => {
        DialogHelper.confirm(this.props.translations["Standard.Msg.Loeschen"]).then(isOK => {
            if (isOK) {
                const data = {
                    problemnr: this._selectedItem.directParent ? this._selectedItem.targetId : this._selectedItem.data.PROBLEMNR,
                    problemnrref: this._selectedItem.directParent ? this._selectedItem.data.PROBLEMNR : this._selectedItem.data.PROBLEMNRREF,
                    allocationId: this._selectedItem.directParent ? this._selectedItem.childAllocationId : this._selectedItem.data.BEZ_ID
                };

                const url = 'ProcedureAllocation/Delete';
                HTTPService.post(url, data)
                    .then(result => {
                        this._getTreeData(true).then(() => {
                            this.props.context.reloadEntity();
                            this.setState({});
                        });
                    });
            }
        });
    }

    handleClickStandardButton = (type: ToolBarStandardButtonType) => {
        if (type === ToolBarStandardButtonType.NEW) {
            this._create();
        } else if (type === ToolBarStandardButtonType.EDIT) {
            this._open();
        } else if (type == ToolBarStandardButtonType.DELETE) {
            this._remove();
        }
    }

    handleClickCustomButton = (id: string) => {
        switch (id) {
            case "open":
                const url = `Procedure/Edit?isWindow=true&id=${encodeURIComponent(this._selectedItem.data.PROBLEMNR)}`;
                const sheet = General.Sheet.Manager.createSheetWithUrl(url, null, { disableTabTitle: true });
                break;
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.context.allocationsTemplate != this.props.context.allocationsTemplate) {
            const options = {
                template: this.baseTemplate + this.props.context.allocationsTemplate
            }
            this._treeRef.setOptions(options);
            this._treeRef.dataSource.read();
        }
    }

    componentDidMount() {
        this._getTreeData(false)
            .then(() => {
                if (!this._error) {
                    this._treeRef = $(this._treeElementRef).kendoTreeView({
                        dataSource: this._treeData,
                        template: this.baseTemplate + this.props.context.allocationsTemplate,
                        select: (e) => {
                            e.preventDefault();
                            $("input[type=radio][name=treeStructurePart]", e.node).first().prop("checked", true);
                            this._selectedItem = e.sender.dataItem(e.node);
                            this.setState({});
                        }
                    }).data("kendoTreeView");
                    this._setRadioButtonVisibility();
                }
                this.setState({});
            });

        $(document).on("click", ".mobile-context-menu", (e) => {
            e.stopPropagation();
            if (this.contextMenu) {
                this.contextMenu.openContextMenu(e.target);
            }
        });
    }

    render() {
        const enabled = this.props.entity.RecordRight.CanWrite && !this._error && this._selectedItem !== null && (this._selectedItem.directParent ? Helper.hasValue(this._selectedItem.childAllocationId) : (Helper.hasValue(this._selectedItem.data) && Helper.hasValue(this._selectedItem.data.BEZ_ID) && this._selectedItem.data.PROBLEMNRREF == this.props.entity.ProblemNr))
        const standardButtons: Array<ToolBarStandardButton> = [];
        standardButtons.push({ type: ToolBarStandardButtonType.NEW, caption: this._translations["Standard.Neu"], enabled: this.props.entity.RecordRight.CanWrite && this.props.entity.RecordRight.CanCreateSubordinatedTickets && !this._error });
        standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: this._translations["Standard.Editieren"], enabled: enabled });
        standardButtons.push({ type: ToolBarStandardButtonType.DELETE, caption: this._translations["Standard.Loeschen"], enabled: enabled });

        const customButtons: Array<ToolBarCustomButton> = [];
        if (Helper.useMobileGui())
            customButtons.push({ id: "open", caption: Helper.getTranslation("InnoBot.OpenTicket"), enabled: !this._selectedItem || !this._selectedItem.data || this._selectedItem.data.PROBLEMNR != this.props.entity.ProblemNr, iconClass: "k-i-hyperlink-open-sm", useContextMenu: true });

        return (
            <div className="flex-container ticket-allocation-container">
                <ToolBar standardButtons={standardButtons}
                    handleStandardButtonClick={this.handleClickStandardButton}
                    customButtons={customButtons}
                    handleCustomButtonClick={this.handleClickCustomButton}
                    useFloatingButtons={Helper.useMobileGui()}
                    contextMenu={{
                        use: Helper.useMobileGui(),
                        filter: ".k-item",
                        target: "ticketAllocationsTree",
                        visible: Helper.useMobileGui(),
                        ref: (ref) => this.contextMenu = ref,
                        open: (params) => {
                            if (params.e.event && params.e.event.type == "contextmenu")
                                params.e.preventDefault();

                            for (let btn of params.buttons) {
                                params.enable(btn, btn.enabled(null));
                            }
                        }
                    }} />
                <div id="ticketAllocationsTree" className="ticketStructureLayout flex-container__item" ref={(r) => this._treeElementRef = r} />
            </div>
        );
    }
}
